import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { ContactUsDialogComponent } from '../contact-us-dialog/contact-us-dialog.component';

@Component({
  selector: 'app-contact-us-button',
  imports: [TranslateModule, DialogModule],
  templateUrl: './contact-us-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ContactUsButtonComponent {
  dialog = inject(Dialog);

  @Input({ required: true }) labelKey!: string;
  @Input() styleClass: string = 'rc-link link-translate';

  openContactForm() {
    this.dialog.open<string>(ContactUsDialogComponent);
  }
}
